export default __webpack_public_path__ + "static/media/Frame 604.7af20d52.png";